module.exports = __webpack_public_path__ + "img/arrow-left-square.9ffd1645.svg";